module.exports = __webpack_public_path__ + "img/ecologic-web.2fc182d9.png";